import { render, staticRenderFns } from "./TabPageLayout.vue?vue&type=template&id=78459a7d&scoped=true"
import script from "./TabPageLayout.vue?vue&type=script&lang=js"
export * from "./TabPageLayout.vue?vue&type=script&lang=js"
import style0 from "./TabPageLayout.vue?vue&type=style&index=0&id=78459a7d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78459a7d",
  null
  
)

export default component.exports